import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { TermsInstrictionInner } from './parts';

import { JSX } from 'react';
import styles from './termsInstruction.module.scss';

export type TermsInstrictionProps =
  SliceComponentProps<Content.TermsInstrictionSlice>;

const TermsInstriction = ({ slice }: TermsInstrictionProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={`${styles.section} ${styles[slice.variation]}`}
    >
      <TermsInstrictionInner slice={slice} />
    </section>
  );
};

export default TermsInstriction;
